import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Device_MANUFACTURE_Interface } from 'src/app/Interface/Device_MANUFACTURE_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceMANUFACTUREService {

  constructor(private http:HttpClient) { }


  GetRecord():Observable<Array<Device_MANUFACTURE_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Device_MANUFACTURE").pipe(
      map(data=>{
        return data as Array<Device_MANUFACTURE_Interface>
      })
    )
  }

  GetSingle(id:Number):Observable<Device_MANUFACTURE_Interface>{
    return this.http.get(environment.BaseUrl + "Daro/Device_MANUFACTURE/GetSingle?id="+id).pipe(
      map(data=>{
        return data as Device_MANUFACTURE_Interface
      })
    )
  }

  GetCalibration(id:Number):Observable<Array<Device_MANUFACTURE_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/Device_MANUFACTURE/GetCalibration?id="+id).pipe(
      map(data=>{
        return data as Array<Device_MANUFACTURE_Interface>
      })
    )
  }

  AddDevice_MANUFACTURE(model: Device_MANUFACTURE_Interface):Observable<Device_MANUFACTURE_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      device_id:model.device_id,
      MANUFACTURE:model.mANUFACTURE,
      MODEL:model.mODEL,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Device_MANUFACTURE/Add",body,{headers}).pipe(
        map(data=>{
          return data as Device_MANUFACTURE_Interface
        })
      )

  }

  EditDevice_MANUFACTURE(model: Device_MANUFACTURE_Interface):Observable<Device_MANUFACTURE_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');


    var body = {
      id:model.id,
      device_id:model.device_id,
      MANUFACTURE:model.mANUFACTURE,
      MODEL:model.mODEL,
      del:false,
      username:'',
      subdate:null
    }


      return this.http.post(environment.BaseUrl + "Daro/Device_MANUFACTURE/Edit",body,{headers}).pipe(
        map(data=>{
          return data as Device_MANUFACTURE_Interface
        })
      )

  }

  DeleteDevice_MANUFACTURE(id:number):Observable<Device_MANUFACTURE_Interface>{

      return this.http.get(environment.BaseUrl + "Daro/Device_MANUFACTURE/Delete?id="+id).pipe(
        map(data=>{
          return data as Device_MANUFACTURE_Interface
        })
      )

  }

  }
